import type { FC, SVGProps } from "react";

const PlayIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="play video icon">
      {/* <title>play video icon</title> */}
      <path
        d="M5.65733 21.5999C4.48299 21.5999 3.6001 20.6399 3.6001 19.5427L3.6001 4.45628C3.6001 3.36852 4.47442 2.3999 5.65776 2.3999C6.03003 2.3999 6.40137 2.50071 6.73009 2.70124L19.0735 10.2444C19.6851 10.6194 20.058 11.2837 20.058 11.9995C20.058 12.7152 19.685 13.3808 19.0735 13.7546L6.73009 21.2977C6.40308 21.497 6.03021 21.5999 5.65733 21.5999Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default PlayIcon;
